import { injectable } from 'inversify';
import type { IPlanRepository, PlanFormData } from '@/domain/repositories/IPlanRepository';
import { Plan } from '@/domain/entities/Plan';

@injectable()
export class MockPlanRepository implements IPlanRepository {
  private mockPlans: Plan[] = [
    Plan.create(1, 'Base', 1, 1, 70000, true, new Date(), new Date()),
    Plan.create(3, 'Avanzado', 1, 1, 115000, true, new Date(), new Date()),
  ];

  async getAll(): Promise<Plan[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return [...this.mockPlans];
  }

  async getById(id: number): Promise<Plan> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const plan = this.mockPlans.find(p => p.id === id);
    if (!plan) {
      throw new Error('Plan not found');
    }
    return plan;
  }

  async create(data: PlanFormData): Promise<Plan> {
    await new Promise(resolve => setTimeout(resolve, 400));
    const newId = Math.max(...this.mockPlans.map(p => p.id)) + 1;
    const newPlan = Plan.create(
      newId,
      data.nombre,
      data.consultorios,
      data.profesionales,
      data.precio,
      true,
      new Date(),
      new Date()
    );
    this.mockPlans.push(newPlan);
    return newPlan;
  }

  async update(id: number, data: PlanFormData): Promise<Plan> {
    await new Promise(resolve => setTimeout(resolve, 400));
    const index = this.mockPlans.findIndex(p => p.id === id);
    if (index === -1) {
      throw new Error('Plan not found');
    }

    const existingPlan = this.mockPlans[index];
    const updatedPlan = Plan.create(
      id,
      data.nombre,
      data.consultorios,
      data.profesionales,
      data.precio,
      existingPlan.isActive(),
      existingPlan.fechaAlta,
      new Date()
    );

    this.mockPlans[index] = updatedPlan;
    return updatedPlan;
  }

  async toggleStatus(id: number): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 300));
    const plan = this.mockPlans.find(p => p.id === id);
    if (plan) {
      if (plan.isActive()) {
        plan.deactivate();
      } else {
        plan.activate();
      }
    }
  }

  async delete(id: number): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 200));
    this.mockPlans = this.mockPlans.filter((p) => p.id !== id);
  }
}
